// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__203__","fileBtn":"File_fileBtn__YUU-g","closeBtn":"File_closeBtn__dkViR","fileSelected":"File_fileSelected__oBPye","disabled":"File_disabled__1AIRS"};